import React from "react";
import { NavLink } from "react-router-dom"; 
import styled from "styled-components";
//import {FaHouse} from "react-icons/fa6";
import MenuItem from "./MenuItem";
import { TrackWidth } from "./TrackSize";
import Login from "./Login";

const NavOuter = styled.div `
  position: relative;
  display:flex;
  justify-content: flex-end;
`;

const Nav = styled.div`
    background: ${({content}) => content.titleBgColor};
    color: ${({content}) => content.titleTextColor};
    display: flex;
    flex-wrap: wrap;
    font-size: 1rem;
    column-gap: 34px;
    row-gap: 10px;
    padding: 5px;
    justify-content: flex-end;
    flex-grow: 1;
`;

const NavHeading = styled.div `
    a.active  { color: ${({content}) => content.highlightColor}; }
    a { color: ${({content}) => content.titleTextColor}; }
    padding: 5px;
`;


export default function TopNavigation({content, setTopNavWidth, windowSize,}) {
      
    return(
        <NavOuter>
            <TrackWidth setSize={setTopNavWidth} windowSize={windowSize}>
                <Nav content={content.styles}>
                    <div></div>
                    <NavHeading content={content.styles}>
                        <NavLink to="/home">Home</NavLink>
                    </NavHeading>

                    {content.sections.map((item) => {
                        if (content.sectionsEnabled[item]) {
                            return (
                                <MenuItem key={item} item={item} page={content[item]} styles={content.styles} type='Horizontal'/>
                            )
                        } else {
                            return null;
                        }
                    })}
                    <Login link={content.login} styles={content.styles}/>
                    <div></div>
                </Nav>
            </TrackWidth>
        </NavOuter>
    )
}

